"use client"

import { Suspense, useEffect } from 'react'
import { useSearchParams } from "next/navigation";


export default function Chatbot() {

    const customStyle = {
        marginRight: '1rem',
        marginBottom: '5rem',
        display: 'none',
        position: 'fixed',
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        height: '65vh',
        border: 'none',
        borderRadius: '1rem',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)',
        width: '30rem'
    };

    useEffect(() => {
        function handleMessage(event: MessageEvent) {
            var iframe = document.getElementById('openassistantgpt-chatbot-iframe') as HTMLIFrameElement | null;
            var buttonIframe = document.getElementById('openassistantgpt-chatbot-button-iframe') as HTMLIFrameElement | null;

            if (event.data === 'openChat') {
                console.log('Toggle chat visibility');
                if (iframe && buttonIframe) {
                    iframe.contentWindow?.postMessage('openChat', '*');
                    buttonIframe.contentWindow?.postMessage('openChat', '*');
                    iframe.style.pointerEvents = 'auto';
                    iframe.style.display = 'block';
                    if (window.innerWidth < 640) {
                        iframe.style.position = 'fixed';
                        iframe.style.width = '100%';
                        iframe.style.height = '100%';
                        iframe.style.top = '0';
                        iframe.style.left = '0';
                        iframe.style.zIndex = '9999';
                    } else {
                        iframe.style.position = 'fixed';
                        iframe.style.width = '30rem';
                        iframe.style.height = '65vh';
                        iframe.style.bottom = '0';
                        iframe.style.right = '0';
                        iframe.style.top = '';
                        iframe.style.left = '';
                    }
                } else {
                    console.error('iframe not found');
                }
            }

            if (event.data === 'closeChat') {
                if (iframe && buttonIframe) {
                    iframe.style.display = 'none';
                    iframe.style.pointerEvents = 'none';
                    iframe.contentWindow?.postMessage('closeChat', '*');
                    buttonIframe.contentWindow?.postMessage('closeChat', '*');
                }
            }
        }

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);


    function Chatbox() {
        const params = useSearchParams()

        if ((params.get('chatbox') || '').match('false')) {
            return <></>
        } else {
            return (
                <>
                    <iframe
                        src={`/embed/clxbh6fxz0007eb78z13ajloc/button?chatbox=false`}
                        scrolling='no'
                        id="openassistantgpt-chatbot-button-iframe"
                        className="fixed bottom-0 right-0 mb-4 z-50 flex items-end inline-block mr-4 w-14 h-14"
                        style={{ border: 'none', background: 'transparent' }}
                        loading="lazy"
                        tabIndex={-1}
                    ></iframe>
                    <iframe
                        src={`/embed/clxbh6fxz0007eb78z13ajloc/window?chatbox=false&withExitX=true`}
                        style={customStyle}
                        allowFullScreen
                        className='z-50'
                        id="openassistantgpt-chatbot-iframe"
                        loading="lazy"
                        tabIndex={-1}
                    ></iframe>
                </>
            )
        }
    }


    return (
        <div>
            <Suspense>
                {
                    <Chatbox />
                }
            </Suspense>
        </div>
    )
}